// frontend/src/components/ReviewsCertifications/ReviewsCertificationsReports/index.jsx
import React from "react";
import ReviewsCertificationsList from "./TestsReviewCertificationList";
import ReviewsCertificationsDetail from "./TestsReviewCertificationDetail";

class TestsReviewCertification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: "list",

      selectedTestCode: null,
      selectedAssetId: null,
      selectedReportType: "pending",
    };
    this.onViewReport = this.onViewReport.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onReportTypeChange = this.onReportTypeChange.bind(this);
  }

  onViewReport(testCode, assetId) {
    // invoked by list component when "Perform Review" / "View" clicked
    this.setState({
      viewMode: "detail",
      selectedTestCode: testCode,
      selectedAssetId: assetId,
    });
  }

  onBack() {
    // go back to list
    this.setState({
      viewMode: "list",
      selectedTestCode: null,
      selectedAssetId: null,
      // keep reportType as before or reset to "pending" if desired
    });
  }

  onReportTypeChange(newType) {
    // propagate to list: update state so list refetches if needed
    this.setState({ selectedReportType: newType });
  }

  render() {
    const { viewMode, selectedTestCode, selectedAssetId, selectedReportType } = this.state;

    if (viewMode === "list") {
      // Render the list view; pass down onViewReport callback and current reportType
      return (
        <ReviewsCertificationsList
          {...this.props}
          reportType={selectedReportType}
          onViewReport={this.onViewReport}
          onReportTypeChange={this.onReportTypeChange}
        />
      );
    } else if (viewMode === "detail") {
      // Render detail view, passing selected params
      return (
        <ReviewsCertificationsDetail
          {...this.props}
          form={selectedTestCode}
          unit={selectedAssetId}
          reportType={selectedReportType}
          onBack={this.onBack}
        />
      );
    }
  }
}

export default TestsReviewCertification;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/TestsReviewCertification/index.jsx